import { gql } from "@apollo/client";

export const TRACK_CURRENT_USER = gql`
  mutation trackCurrentUser(
    $clientCode: String!
    $applicationCode: String!
    $trackingInfo: TrackingInfo!
  ) {
    trackCurrentUser(
      clientCode: $clientCode
      applicationCode: $applicationCode
      trackingInfo: $trackingInfo
    )
  }
`;
